import omit from 'lodash/omit';

import { IAddress, IAutoPolicy } from '../../../interfaces';

export type TUpdateRatingAdressOnPolicy = {
  normalizedAddress: IAddress;
  line2: string | null;
  timezone: string;
};

export function updateRatingAddressOnPolicy(
  { normalizedAddress, line2, timezone }: TUpdateRatingAdressOnPolicy,
  stagedPolicy: IAutoPolicy
) {
  const updatedRatingAddress = {
    ...normalizedAddress,
    line2,
    timezone,
  };

  const updatedVehicles = stagedPolicy?.details?.vehicles.map((vehicle) => {
    return {
      ...vehicle,
      garage_address: omit(updatedRatingAddress, [
        'latitude',
        'longitude',
        'timezone',
      ]),
    };
  });

  const updatedStagedPolicy = {
    ...stagedPolicy,
    rating_address: updatedRatingAddress,
    details: {
      ...stagedPolicy.details,
      vehicles: updatedVehicles,
    },
  };

  return updatedStagedPolicy;
}
